// Canonical release blog document for Okie Dokie.
import { defineDocument } from '../../schema';
export const blogOkieDokieStampsItsWayIntoTheGameLibraryDocument = defineDocument({
    id: 'blog:okie-dokie-stamps-its-way-into-the-game-library',
    kind: 'blog',
    slug: 'okie-dokie-stamps-its-way-into-the-game-library',
    route: '/blog/okie-dokie-stamps-its-way-into-the-game-library',
    seo: {
        title: 'Okie Dokie Stamps Its Way Into the Game Library',
        description: 'A Discord riff with okiedokie24 becomes official county business in our newest player-driven party game.',
        imageAsset: 'coverOkieDokie',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Airhead Blog',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Okie Dokie Stamps Its Way Into the Game Library',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'A Discord riff with okiedokie24 becomes official county business in our newest player-driven party game.',
            },
        ],
        imageAsset: 'coverOkieDokie',
        imageAlt: 'Okie Dokie cover art',
        showDescription: true,
        background: 'blurred-image',
    },
    meta: {
        author: 'Jay',
        publishedAt: new Date('2026-06-30T00:00:00.000Z'),
        updatedAt: new Date('2026-06-30T00:00:00.000Z'),
        tags: ['games'],
    },
    sections: [
        {
            id: 'article',
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'The newest filing in our game library started, as many official Airhead matters do, in ',
                        },
                        {
                            type: 'link',
                            href: 'https://discord.gg/rfFTVAqHwH',
                            children: [
                                {
                                    type: 'text',
                                    text: "Poppy's Pals Discord",
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: '. A conversation with a community member sparked the idea that turned into our latest game, ',
                        },
                        {
                            type: 'link',
                            href: '/discover/games/okie-dokie',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Okie Dokie',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: '.',
                        },
                    ],
                },
            ],
            sections: [
                {
                    id: 'article__from-discord-to-the-docket',
                    title: [
                        {
                            type: 'text',
                            text: 'From Discord to the Docket',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'The idea for a write-in game where the prompts would not be stock questions sitting on a shelf came from our friend, ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'okiedokie24',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: '. To take it a step further and provide a unique Airhead twist, we discussed players suggesting the themes that the generated prompts are based on.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'There was only ever going to be one name for the game: when people share their ideas to help shape Airhead Games, the least I can do is honor them somehow! With “Okie Dokie” on my mind, the game’s narrative quickly moved towards an imaginary county office that approves absolutely everything. After an outline of the game came together, it went back to ',
                                },
                                {
                                    type: 'em',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'okiedokie24',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' in Discord. They "loved everything about" it, so with their “OK” the game had its stamp of approval.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__filing-paperwork-is-fun',
                    title: [
                        {
                            type: 'text',
                            text: 'Filing Paperwork is Fun',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Okie Dokie opens with a docket. A few candidates are offered as potential case themes, and every player has the opportunity to add their own ideas, too. The room votes on which case themes have the highest potential, and the three leading vote-getters become the game material.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'An official document is produced for each of the themes with blanks for players to fill in: incident reports, permit applications, complaint forms, and other deeply serious county business. The prompts are answered and the answers go head-to-head, with players voting to enter the best ones into the official government records.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Like all great government departments, the Bureau of Okie Dokie has very little time to accomplish anything substantial before closing for the day. The final round of the game is an all-play in which everybody completes the End of Day Memo to address one of the most pressing issues with an official recommendation from the bureau. Players vote for their favorite, and more points are awarded before the final scores are tallied.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__not-just-another-day-at-the-office',
                    title: [
                        {
                            type: 'text',
                            text: 'Not Just Another Day at the Office',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Okie Dokie is a classic representation of what Airhead Games strives for: games that take the shape of the communities who play them.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Player ideas lead to fresh prompts, prompts lead to creative and funny answers from players, and the game continues to improvise from there. The same group can play twice in a row and never end up with the same day at the bureau.',
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'This uniquely interactive way of party gaming allows your humor to shine through, making each round feel tailored to your group instead of replaying canned content and scripted jokes.',
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'article__now-accepting-new-cases',
                    title: [
                        {
                            type: 'text',
                            text: 'Now Accepting New Cases',
                        },
                    ],
                    blocks: [
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "I would love to make more games with the community. When people in the community share ideas to help shape Airhead Games, it breathes life into the entire development process. As a solo dev, I don't want to build in a vacuum; I want to create games that this community actually wants to stream and play.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: "Airhead Games is a place where your opinions are genuinely heard and your ideas are permanently honored inside the games and features on our platform. For me, creating alongside you is infinitely more fun than working alone. Let's lock in this feedback loop: you inspire, I build, we play, and we keep growing this world together.",
                                },
                            ],
                        },
                        {
                            type: 'paragraph',
                            content: [
                                {
                                    type: 'text',
                                    text: 'Share your ideas in ',
                                },
                                {
                                    type: 'link',
                                    href: 'https://discord.gg/rfFTVAqHwH',
                                    children: [
                                        {
                                            type: 'text',
                                            text: "Poppy's Pals Discord",
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' and ',
                                },
                                {
                                    type: 'link',
                                    href: '/library',
                                    children: [
                                        {
                                            type: 'text',
                                            text: 'play Okie Dokie',
                                        },
                                    ],
                                },
                                {
                                    type: 'text',
                                    text: ' to enjoy our latest community collaboration.',
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'article-actions',
            widgets: [
                {
                    type: 'relatedDocuments',
                    limit: 4,
                },
            ],
        },
    ],
});
//# sourceMappingURL=okie-dokie-stamps-its-way-into-the-game-library.js.map